import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseList } from '../../classes/base-list';
import { ToastrService } from 'ngx-toastr';
import { DominioService } from '../../services/dominio.service';
import { OficinaComercialService } from '../../services/oficina-comercial.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html'
})
export class PerfilComponent implements OnInit {

  dataForm: FormGroup;

  tiposDocumentos: BaseList = new BaseList();

  oficinasComerciales: BaseList = new BaseList();

  sexoList: BaseList = new BaseList();

  estadoCivilList: BaseList = new BaseList();

  constructor(private toastr: ToastrService,
    private fb: FormBuilder, private dominioService: DominioService, private oficinaComercialService: OficinaComercialService) {
    this.listarTiposDocumentos();
    this.listarOficinasComerciales();
    this.listarSexo();
    this.listarEstadoCivil();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    let data = JSON.parse(localStorage.getItem('session'));
    console.log(data.usuario.split('-'));
    let codigoUsuario = data.usuario.split(' - ')[0];
    let casilla = data.usuario.split(' - ')[1];
    this.dataForm = this.fb.group({
      codigoUsuario: [codigoUsuario, [Validators.required]], 
      casilla: [casilla, [Validators.required]]
    })

  }

  listarSexo() {
    let data = {
      filters: { nombre: 'sexo', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.sexoList = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarEstadoCivil() {
    let data = {
      filters: { nombre: 'estado_civil', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.estadoCivilList = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarTiposDocumentos() {
    let data = {
      filters: { nombre: 'tipo_documento', vigente: true },
      count: -1
    }
    this.dominioService.listar(data).subscribe(
      resp => {
        this.tiposDocumentos = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  listarOficinasComerciales() {
    let data = {
      count: -1
    }
    this.oficinaComercialService.listar(data).subscribe(
      resp => {
        this.oficinasComerciales = resp;
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    )
  }

  editarDatos() {

  }

}
